(function (angular) {
	
	app = angular.module('harriApp');
	var chatIntervalRef;
	app.directive('chatBox', ["httpHelper", "chatAPI", "hUser", "$timeout", "$interval", "$rootScope", "$state", "Upload", "$location", function (httpHelper, chatAPI, hUser, $timeout, $interval, $rootScope, $state, Upload, $location) {
		return {
			templateUrl: function (elem, attr) {
				if (attr.isInverse) {
					return "../modules/chat/views/inverse-chat-box.html";
				}
				return "../modules/chat/views/chat-box.html";
			},
			restrict: 'E',
			replace: true,
			scope: {
				'senderType': '@',
				'appId': '=',
				'activeId': '=',
				'candImageId': '@',
				'candId': '@',
				'isAms': '=?',
				'isInverse': '=?',
			},
			link: function ($scope, iElement, iAttrs) {
                const PLACEHOLDER_CODES = {
                    view_job_place_holder: { code: 'view_job_place_holder', label: $filter('translate')('Click here to apply')},
                    select_slot_place_holder: {code: 'select_slot_place_holder', label: $filter('translate')('Confirm interview')},
                    start_video_screening_placeholder: {code: 'start_video_screening_placeholder', label: $filter('translate')('Start your screening')},
                }
                let messageData;

				if (iAttrs.candImageId) {
					$scope.candImageId = iAttrs.candImageId;
				}
				
				if (iAttrs.candId) {
					$scope.candId = iAttrs.candId;
				}
                var url = $location.url();

                $scope.chatPlaceholder = iAttrs.senderType == 'Employer' ? $filter('translate')('Send a message to the applicant') : $filter('translate')('Send a message to the employer');
				/*
				 This function search for the last msg with id we have to get the newer one
				 */
				$scope.getLastMsgSentId = function () {
					var id = 0;
					var i = $scope.isInverse ? 0 : $scope.msgs.length - 1;
					if ($scope.isInverse) {
						for (i; i < $scope.msgs.length; i++) {
							if ($scope.msgs[i].id) {
								id = $scope.msgs[i].id;
								break;
							}
						}
					}
					else {
						for (i; i >= 0; i--) {
							if ($scope.msgs[i].id) {
								id = $scope.msgs[i].id;
								break;
							}
						}
					}
					return id;
				};

                var handleUnauthorizedError = function () {
                    hAlert(
                        $filter("translate")("Something went wrong!"),
                        $filter("translate")("You don’t have the sufficient privileges to perform this operation."),
                        function () {
                            if (url.indexOf('messages') > -1) {
                                window.location = window.location;
                            } else {
                                Utils.redirectToWorkspace(`appLayout.harriSH.dashboard-hiring`);
                            }
                        }
                    );
                };
				
				/**
				 * Send Message
				 */
				$scope.sendMessage = function (event) {
                    var chatbox = $(iElement).find('.chat-input');

					if (($scope.sending || !$scope.chat_line || $.trim($scope.chat_line) == '')
							&& !$scope.selectedFiles.length) {
						$timeout(function () {
                            chatbox.focus();
						});
						return false;
					}
					
					$scope.msgs[$scope.isInverse ? 'unshift' : 'push']({
						'body': $scope.chat_line,
						'sender_type': iAttrs.senderType,
						'status': 'Sending'
					});
					
					$scope.sending = true;
                    $scope.focus = false;
					if ($scope.msgs.length > 5) {
						$scope.msgLimit++;
					}
					
					$scope.updateModalBackDrop();
					
					
					sendMessage($scope.chat_line, $scope.selectedFiles)
							.then(function (response) {
								$scope.msgs[$scope.isInverse ? 0 : $scope.msgs.length - 1].id = parseInt(response.message_id);
								$scope.msgs[$scope.isInverse ? 0 : $scope.msgs.length - 1].attachments = response.attachments || null;
								$scope.msgs[$scope.isInverse ? 0 : $scope.msgs.length - 1].created = moment().toString();
								$scope.msgs[$scope.isInverse ? 0 : $scope.msgs.length - 1].status = 'Sent';
								$scope.sending = false;
								scrollBottomAndFocus();
								$scope.chat_line = '';
								$scope.selectedFiles = [];
                                resetVirtualInput();
							}, function () {
								$scope.msgs[$scope.isInverse ? 0 : $scope.msgs.length - 1].status = 'Error';
								$scope.msgs[$scope.isInverse ? 0 : $scope.msgs.length - 1].attachments = response.attachments || null;
								$scope.sending = false;
								$scope.created = moment().toString();
								scrollBottomAndFocus();
								$scope.chat_line = '';
								$scope.selectedFiles = [];
							});
					
					
				};
				
				
				/**
				 * Scroll to bottom
				 */
				$scope.scrollToBottom = function () {
					setTimeout(function () {
						var msgBox = $('.chat-box-content')[0];
						if (msgBox && msgBox.scrollHeight) {
							msgBox.scrollTop = msgBox.scrollHeight;
						}
					}, 200);
				};
				
				/**
				 * scroll to bottom of chat line and focus
				 */
				var scrollBottomAndFocus = function () {
					$timeout(function () {
						
						$scope.scrollToBottom();
						$scope.updateModalBackDrop();
						
						if ($('#speedy-screen-modal').length > 0) {
							$('#speedy-screen-modal').data('bs.modal').handleUpdate();
						}

                        setTimeout(function () {
                            $(iElement).find('.chat-input').focus();
                        }, 100);
					});
				};
				
				
				$scope.updateModalBackDrop = function () {
					$timeout(function () {
						var $SSModal = $('#speedy-screen-modal');
						if ($SSModal.length > 0) {
							$SSModal.data('bs.modal').handleUpdate();
						}
					});
				};
				
				
				/**
				 * setMsgsAsRead
				 */
				$scope.setMsgsAsRead = function () {
					var promise = chatAPI.setMessagesAsRead($scope.msgs, iAttrs.senderType == 'Employer' ? 'Applicant' : 'Employer');
					if (promise) {
						promise.then(function (e) {
							$rootScope.$broadcast('updateHeaderNotf', { forceUpdate: true });
						});
					}
				};
				
				
				/**
				 * Send Message On Enter
				 *
				 * @param e
				 */
				$scope.sendMessageOnEnter = function (e) {
					if ($scope.send_on_enter && e.keyCode == 13 && !e.shiftKey) {
						$scope.sendMessage(e);
                        e.preventDefault();
					}
				};
				
				
				function init() {
					// Vars
					$scope.msgs = [];
					$scope.brand_img = '';
					$scope.sending = false;
					$scope.focus = false;
					$scope.user_id = hUser.data.user.id;
                    messageData = null;
					
					// get user img
					if (iAttrs.senderType != 'Employer') {
						hUser.getUserImages().then(function (images) {
							if (images.hasOwnProperty('user_profile') && images.user_profile.uuid) {
								$scope.candImageId = images && images.user_profile && images.user_profile.uuid;
								$scope.candId = hUser.data && hUser.data.user && hUser.data.user.id;
							}
						});
					}
					
					/**
					 * Check if send on inter is activated
					 */
					$scope.send_on_enter = HStorageManager.get({
                        key: 'send_on_enter',
                        storageLevel: HStorageManager.StorageLevels.COOKIES
                    });

					
					/**
					 * getMessages
					 */
					chatAPI.getMessages($scope.appId).then(function (response) {
						if (response.data.messages) {
							if ($scope.isInverse) {
								$scope.msgs = _.chain(response.data.messages).reverse().value();
								$scope.msgLimit = 5;
								$scope.msgOffset = 0;
								if ($scope.msgs.length > 5) {
									$scope.moreMessages = true;
								}
							}
							else {
								$scope.msgs = response.data.messages;
							}
							$scope.candidateSlug = response.data.applicant_info.slug;
                            messageData = response.data;
							
							for (var i = 0; i < $scope.msgs.length; i++) {
								if ($scope.msgs[i].sender_type == 'Employer' && $scope.msgs[i].body) {
									$scope.msgs[i].body = replaceMessageShortcodes($scope.msgs[i].body, messageData, $scope.msgs[i].placeholders);
								}
							}
							
							$scope.setMsgsAsRead();
                            if (!$scope.isAms) {
                                $timeout(function () {
                                    scrollBottomAndFocus();
                                });
                            }
						} else if (response.status_code === 403) {
                            handleUnauthorizedError();
                        }
						
						$scope.brandImg = response.data.brand_image;
                        $scope.brandImgPath = response.data.brand_image_path;
						$scope.brandImageFileExtension = response.data.brand_image_file_extension;
						$scope.brandId = response.data.brand_id;
						$scope.brandSlug = response.data.brand_slug;
						$scope.isBrandArchived = response.data.is_brand_archived;

                        $scope.bucketId = 'DIRECT';
                        $scope.jobId = response.data['job_id'];
					})
                        .catch(function (err) {
                            console.error(err);
                        });
					
					/**
					 * Poll for new messages each x seconds
					 */
					$interval.cancel(chatIntervalRef);
					chatIntervalRef = $interval(function () {

                        if (hUser.isLoggedIn()) {
                            var last_msg_id = $scope.getLastMsgSentId();
                            if ($scope.appId && !$scope.sending) {
                                chatAPI.getNewMsgs($scope.appId, last_msg_id).then(function (resp) {
                                    $rootScope.$broadcast('setReadAsZeroIfSelected', $scope.appId);
                                    if (resp.data.data.messages) {
                                        messageData = messageData || resp.data.data;

                                        _.each(resp.data.data.messages, function (msg) {
                                            if (msg.sender_type === 'Employer' && msg.body) {
                                                msg.body = replaceMessageShortcodes(msg.body, messageData, msg.placeholders);
                                            }
                                            $scope.msgs[$scope.isInverse ? 'unshift' : 'push'](msg);
                                            if ($scope.isInverse) {
                                                $scope.msgLimit++;
                                            }
                                        });

                                        $timeout(function () {
                                            $scope.scrollToBottom();
                                            $scope.setMsgsAsRead();
                                        });
                                    }
                                }).catch(function (err) {
                                    if (err && err.data && err.data.errors && err.data.errors[0].status === 403) {
                                        handleUnauthorizedError();
                                    }
                                });
                            }
                        }

					}, publicConfiguration.refreshRate);
				}
				
				
				/**
				 * Lsn to send_on_enter and write
				 * the value to cookies
				 */
				$scope.$watch('send_on_enter', function (val) {
					if (val != undefined) {
                        HStorageManager.put({
                            key: 'send_on_enter',
                            storageLevel: HStorageManager.StorageLevels.COOKIES,
                            value: val
                        });
					}
				});
				
				
				// $scope.candImageId = $scope.candImageId;
				$scope.$watch('appId', function (newVal, oldVal) {
                    if (newVal) {
                        init();
                    }
				});

                const getHrefForCTA = (code, params, data) => {
                    const app_id = params.messages[0]?.application_id;

                    switch (code) {
                        case PLACEHOLDER_CODES.view_job_place_holder.code:
                            let links_part = [], job_url;

                            links_part.push($state.href('homepage', {}, {absolute: true}));
                            links_part[0] = links_part[0].slice(0,-1);

                            if (params.access_mode === "PRIVATE"){
                                links_part.push('internal');
                            }
                            links_part.push(params['brand_slug']);
                            links_part.push('job');
                            links_part.push(params['job_id'] + '-' + params['position_code']);

                            job_url = join_query_link(links_part.join('/'), {'ref': 'invitation'});
                            return job_url;
                        case PLACEHOLDER_CODES.select_slot_place_holder.code:
                            return `./interview/${app_id}`;
                        case PLACEHOLDER_CODES.start_video_screening_placeholder.code:
                            const interview_id = data?.interview_id;
                            return interview_id ? `/interview-video/${app_id}/${interview_id}` : '';
                        default:
                            return '';
                    }
                }

				const replaceMessageShortcodes = (text, params, placeholders) => {
                    if (placeholders) {
                        for (let i = 0; i < placeholders.length; i++) {
                            let hrefUrl = getHrefForCTA(placeholders[i].code, params, placeholders[i].extra_data || {}) || placeholders[i].link;
                            let ctaText = PLACEHOLDER_CODES[placeholders[i].code]?.label || placeholders[i].text;
                            text = text.replace(`{${placeholders[i].code}}`, `<br><br> <a href="${hrefUrl}" class="hui hui-button md outline bg-white hui-primary" target="_blank">${ctaText}</a> <br>`);
                        }
                    }
					return text;
				};
				
				$scope.selectedFiles = [];
				
				$scope.beforeFilesChanged = function () {
					$scope.processingFiles = true;
				};
				
				$scope.removeSelectedFile = function (file, index, overflow) {
					if (overflow) {
						$scope.selectedFiles.splice(index + $scope.attachments_offset, 1);
					}
					else {
						$scope.selectedFiles.splice(index, 1);
					}
				};
				
				$scope.onFilesChanged = function ($files, $file, $newFiles, $duplicateFiles, $invalidFiles, $event) {
					$scope.processingFiles = false;
					
					if ($newFiles.length) {
						var title = $filter("translate")("Invalid files:");
						var content = "";
						
						for (var i in $newFiles) {
							var file = $newFiles[i];
							
							if (file.$error) {
								content = content + file.name + " is bigger than 18MB" + "<br/>";
							}
						}
						
						if (content) {
							hAlert(title, content);
						}
					}
				};
				
				//send a new message with optional media attachement
				var sendMessage = function (content, files) {
					
					var defer = $q.defer();
					
					Upload.upload({
						url: publicConfiguration.APIServerBaseURL + 'applications/' + $scope.appId + '/messages',
						withCredentials: true,
						headers: {},
						method: "POST",
						data: {
							message_body: content,
							files: files
						},
						arrayKey: "[]"
					}).progress(function (evt) {
						
						$scope.sendingProgress = 100 * ((evt.loaded || 0) / evt.total);
						
						setTimeout(function () {
							$scope.$digest();
						}, 1);
						
					}).success(function (data, status, headers, config) {
						if (data.status_code == 200) {
							defer.resolve({
								applicationId: $scope.appId,
								message_body: content,
								attachments: data.data.attachments,
								message_id: data.data.message_id
							});
						} else if (data.status_code === 403) {
                            handleUnauthorizedError();
                            defer.reject({error: data});
                        }
						else {
							console.error(data);
							//reject doc
							defer.reject({
								error: data,
								applicationId: $scope.appId,
								message_body: content,
								attachments: files
							});
						}
					}).error(function (reason) {
						//log error
						console.error(reason);
						//reject doc
						defer.reject({
							error: reason,
							applicationId: $scope.appId,
							message_body: content,
							attachments: files
						});
					});
					
					return defer.promise;
				};
				
				$scope.loadMoreMessages = function () {
					if ($scope.msgLimit < $scope.msgs.length) {
						var diff = $scope.msgs.length - $scope.msgLimit;
						
						if (diff > 5) {
							$scope.msgLimit += 5;
							$scope.moreMessages = true;
						}
						else {
							$scope.msgLimit += diff;
							$scope.moreMessages = false;
						}
					}
				};
				
				var virtualInput = null;
				var textareaInput = null;

				var resetVirtualInput = function () {

                    virtualInput.html('');
                    textareaInput.height(virtualInput.height());
                    $(".chat-box-content").css("bottom", ($(".chat-box-text").height() + 6));
                };

				$timeout(function () {
					$("<div id='virtual-chat-input'></div>").insertAfter("textarea.chat-input");
					textareaInput = $('textarea.chat-input');
					virtualInput = $("#virtual-chat-input");

					virtualInput.css("position", "absolute");
					virtualInput.css("top", "-118px");
					virtualInput.css("left", "38px");
					virtualInput.css("visibility", "hidden");
					virtualInput.css("font-size", textareaInput.css('font-size'));
					virtualInput.css("padding", textareaInput.css('padding'));
					virtualInput.css("line height", textareaInput.css('line-height'));
					virtualInput.css("width", textareaInput.outerWidth());
					virtualInput.css("min-height", textareaInput.outerHeight());
					virtualInput.css("white-space", "pre-wrap");
				}, 2000);
				
				$('textarea.chat-input').on('keyup', function ($event) {
					
					var lht = parseInt($(this).css('lineHeight'), 10);
					
					var lines = parseInt($(this).prop('scrollHeight') / lht);

					virtualInput.html($(this).val());

                    if ($event.keyCode === 13) {
						virtualInput.html(virtualInput.html() + ' ');
					}

                    textareaInput.height(virtualInput.height());
                    $(".chat-box-content").css("bottom", ($(".chat-box-text").height() + 6));
                    $scope.scrollToBottom();

				});
				
				$scope.$watch("selectedFiles.length", function (newVal, oldVal) {
					
					$timeout(function () {
						var chatboxContent = $(".chat-box-content");

                        if (!isNaN(chatboxContent.css('bottom'))) {
                            var chatboxContentBottom = parseInt(chatboxContent.css('bottom').replace("px", ""));

                            if (newVal && !oldVal) {
                                chatboxContent.css("bottom", chatboxContentBottom + 35);
                                $scope.scrollToBottom();
                            }
                            if (!newVal && oldVal) {
                                chatboxContent.css("bottom", chatboxContentBottom - 35);
                            }
                        }

					}, 10);
				});
				
				if($(window).width() <= 768 && $(window).width() > 360){
					$scope.attachments_offset = 1;
				}
				else if ($(window).width() <= 360) {
					$scope.attachments_offset = 0;
				}
				else {
					$scope.attachments_offset = 2;
				}
				
				$scope.$on("$destroy", function () {
					$interval.cancel(chatIntervalRef);
					$('textarea.chat-input').off('keyup');
				});
				
			}
		};
	}]);
	
	
	app.directive('chatRow', ['hUser', function (hUser) {
		return {
			templateUrl: "../modules/chat/views/chat-row.html",
			restrict: 'E',
			replace: true,
			scope: {
				'msg': '=',
				'candImageId': '=',
				'candId': '=',
				'brandImg': '=',
                'brandImgPath': '=',
				'brandImageFileExtension': '=',
				'brandId': '=',
				'candSlug': '=?',
				'brandSlug': '=?',
				'bucketId': '=?',
				'appId': '=?',
				'jobId': '=?',
                'isAms': '=?'
			},
			link: function (scope, iElement, iAttrs) {
				scope.getCandidateURL = function () {
                    if (hUser.isEmployer()) {
                        return "/ams/" + scope.jobId + "/application/" + scope.bucketId + "/" + scope.appId;
                    }

                    return "/" + scope.candSlug;
                };
			}
		};
	}]);
	
	
	app.directive('setSelectedAppId', ["$rootScope", function ($rootScope) {
		return {
			link: function (scope, iElement, iAttrs) {
				
				$(iElement).click(function () {
					$rootScope.$broadcast('newSelectedAppId', iAttrs['setSelectedAppId']);
				});
			}
		};
	}]);
	
	
	app.directive('setSelectedBrandId', ["$rootScope", function ($rootScope) {
		return {
			link: function (scope, iElement, iAttrs) {
				
				$(iElement).click(function () {
					$rootScope.$broadcast('newSelectedBrandId', iAttrs['setSelectedBrandId']);
//                scope.$apply(function () {
//                    scope.selected_app_id = iAttrs['setSelectedAppId'];
//                });
				});
			}
		};
	}]);
	
	app.directive('scrollToSelectedDiv', ['$timeout', function ($timeout) {
		return {
			link: function ($scope, iElement, iAttrs) {
				var $appInfoContent, $selected;
				$scope.scrollToSelectedDiv = function () {
					$timeout(function () {
						$selected = $('.selected');
						if ($selected.length) {
							var $appInfoContent = $('.app-info-content');
							$appInfoContent.scrollTop($appInfoContent.scrollTop() + $('.selected').offset().top - 150);
						}
					});
				};
				
				$scope.$watch('first_request', function (newVal, oldVal) {
					$scope.scrollToSelectedDiv();
				});
			}
		}
	}]);
	
	app.directive('isScrolledBottom', ["$timeout", "$rootScope", function ($timeout, $rootScope) {
		var locked = false;
		return {
			link: function ($scope, iElement, iAttrs) {
				iElement.scroll(function () {
					var $appScroll = $('.app-info-content.app-info-content__scrollable');
					var current_scroll_pos = $appScroll.scrollTop() + $appScroll.height();
					
					if (current_scroll_pos + 200 >= $appScroll[0].scrollHeight && !locked) {
						
						$rootScope.$broadcast('chatReachedBottom');
						locked = true;
					}
				});
				
				$scope.$on('releaseChatScrollLock', function (e) {
					locked = false;
				});
			}
		}
	}]);
	
	app.directive('messageAttachment', function () {
		return {
			restrict: 'A',
			scope: {
				'file': '='
			},
			link: function ($scope, iElement, iAttrs) {
				
				var fileUrl = $scope.file && $scope.file.href;
				
				$(iElement).attr('href', fileUrl);
				$(iElement).attr('target', '_blank');
			}
		}
	});
	
})(angular);
